import { sub } from 'date-fns';

import { Filter } from '~/evifields/src/types/Filter';

import { InitiatorType } from './types';

const initiatorTypeOptionLabels: Record<InitiatorType, string> = {
  API: 'API',
  USER: 'USER',
};

const getInitialDateValues = () => {
  const today = new Date();
  const sevenDaysAgo = sub(new Date(), { days: 7 });

  return [sevenDaysAgo, today];
};

export const MAX_AUDIT_LOGS_COUNT = 50000;

export const initialFilters: Filter[] = [
  {
    id: 'activity',
    fieldId: 'activity',
    operatorId: 'equals', //TODO: rework to 'contains_any' once BE is ready
    values: ['VIEW'],
    fieldType: 'text',
  },
  {
    id: 'entityType',
    fieldId: 'entityType',
    operatorId: 'equals',
    values: ['DOCUMENT'],
    fieldType: 'text',
  },
  {
    id: 'datetime',
    fieldId: 'datetime',
    operatorId: 'date_between',
    values: getInitialDateValues(),
    fieldType: 'date',
  },
];

export const initiatorTypeOptions = Object.entries(
  initiatorTypeOptionLabels,
).map(([value, label]) => ({ value, label }));
